<script lang="ts" setup>
import type { ToasterProps } from "vue-sonner"
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon, XIcon } from "@lucide/vue"
import { Toaster as Sonner } from "vue-sonner"
// vue-sonner 2.x вынес стили в отдельный файл — без импорта тост рендерится
// без оформления и позиционирования (вылезает голым текстом снизу-слева).
import "vue-sonner/style.css"
import { cn } from "@/lib/utils"

const props = defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    :class="cn('toaster group', props.class)"
    :style="{
      // refined: тост плотный (стекло убрано) — solid popover-фон + тень,
      // без blur. Токены проекта — с префиксом --color-* (shadcn-генератор
      // ставит голые --popover, которых тут нет → невалидный color-mix).
      '--normal-bg': 'var(--color-popover)',
      '--normal-text': 'var(--color-popover-foreground)',
      '--normal-border': 'var(--color-border)',
      '--border-radius': 'var(--radius)',
    }"
    v-bind="props"
  >
    <template #success-icon>
      <CircleCheckIcon class="size-4" />
    </template>
    <template #info-icon>
      <InfoIcon class="size-4" />
    </template>
    <template #warning-icon>
      <TriangleAlertIcon class="size-4" />
    </template>
    <template #error-icon>
      <OctagonXIcon class="size-4" />
    </template>
    <template #loading-icon>
      <div>
        <Loader2Icon class="size-4 animate-spin" />
      </div>
    </template>
    <template #close-icon>
      <XIcon class="size-4" />
    </template>
  </Sonner>
</template>

<style>
/* §6-BIS.9: тон тоста — только цветом иконки, боковых полос/фона нет. */
[data-sonner-toast][data-type='success'] [data-icon] {
  color: var(--color-success);
}
[data-sonner-toast][data-type='warning'] [data-icon] {
  color: var(--color-warning);
}
[data-sonner-toast][data-type='error'] [data-icon] {
  color: var(--color-destructive);
}
[data-sonner-toast][data-type='info'] [data-icon] {
  color: var(--color-brand);
}
</style>
